import Navigation from "components/LandingPage/Navigation/Navigation";
import Hero from "components/LandingPage/Hero/Hero";
import USPSection from "components/LandingPage/USPSection/USPSection";
import Features from "components/LandingPage/Features/Features";
import FAQ from "components/LandingPage/FAQ/FAQ";
import CTA from "components/LandingPage/CTA/CTA";
import About from "components/LandingPage/About/About";
import Footer from "components/LandingPage/Footer/Footer";
import "./Landing.scss";

const Landing = () => {
  return (
    <div className="Landing">
      <Navigation />
      <Hero />
      <USPSection />
      <Features />
      <FAQ />
      <CTA />
      <About />
      <Footer />
    </div>
  )
}

export default Landing;